module.exports = __webpack_public_path__ + "img/auto_texts_hover.8309136a.svg";